import {publish} from '@/script/event.mjs'

export const saveMap = () => () => {
    return function () {
        return this.runAction(
            async () => {
                const _n = this.nodeProxy(this.root)
                await _n.updateMigrate()
                publish(this, 'save')
            },

            {action: '保存地图'},
        )
    }
}
